import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule,ReactiveFormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { MasterProductGimmickEditPageRoutingModule } from './master-product-gimmick-edit-routing.module';

import { MasterProductGimmickEditPage } from './master-product-gimmick-edit.page';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    IonicModule,
    MasterProductGimmickEditPageRoutingModule
  ],
  declarations: [MasterProductGimmickEditPage]
})
export class MasterProductGimmickEditPageModule {}
